import script from "./Balance_result.vue?vue&type=script&setup=true&lang=js"
export * from "./Balance_result.vue?vue&type=script&setup=true&lang=js"

import "./Balance_result.vue?vue&type=style&index=0&id=5fe34048&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe34048"]])

export default __exports__